export const GET_LOGS = "GET_LOGS";
export const LOGS_ERROR = "LOGS_ERROR";
export const SET_LOADING = "SET_LOADING";
